import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../hooks/useAuth';
import ReportReqBuyDetail from '../dialog/report/report-req-buy-detail';
import ReportFilter from './report-filter';
import { useState } from 'react';
import { blue } from '@mui/material/colors';


function ReportReqFinal() {
    const { authData, authDataLang } = useAuth()

    const [dataFilters, setDataFilters] = useState('')
    // const [error, setError] = useState(false)
    // const [loading, setLoding] = useState(false)
    // const [countShow, setCountShow] = useState(10)
    // const [defPage, setDefPage] = useState(1)
    // const [searchFact, setSearchFact] = useState('')

    const handlerFilters = value => {
        setDataFilters(value)
    }
    // useEffect(()=>{
    //     window.scrollTo(0, 0)
    //     setLoding(true)
    //     const getData = async() =>{
    //         await getShopingNow(authData?.token, defPage, countShow, '&req_final=false')
    //         .then(data => {
    //             setMaterials(data)
    //             console.log(data)
    //             setLoding(false)
    //         }).catch( e => {
    //             setError(true)
    //             setLoding(false)
    //         })
    //     }
    //     getData()
    // }, [])

  // if (error) return <h1> Error </h1> 
    // if (loading) return <ProgressWait statusWait={true}/> 
  
  return (
    <React.Fragment>
        <div style={{width: '100%', minHeight: 1000}}  dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
            <Paper square sx={{ display: 'block', overflow: 'auto', margin: 'auto', backgroundColor: blue[200] }}>
                <Typography 
                    fontFamily={'b_mitra'}
                    gutterBottom 
                    component="div" 
                    variant="h4" 
                    color={blue[900]}
                    sx={{ p: 2, pb: 0, backgroundColor: blue[200] }}
                    >
                    گزارش جامع:
                    
                </Typography>
                <ReportFilter onClose={handlerFilters}/>
                {authData &&
                    <div >
                        <ReportReqBuyDetail filters={dataFilters}/>
                    </div>
                }
            </Paper>
        </div>
    </React.Fragment>
  )
}

export default ReportReqFinal
